/**
 * Supabase client singleton.
 *
 * Reads the project URL + public anon key from Vite env
 * (VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY). Both are PUBLIC and safe to ship —
 * Row-Level Security protects the data, not secrecy of this key.
 *
 * If the env vars are missing, `supabase` is null and the UI shows a "configure .env"
 * notice instead of crashing, so the app still boots during setup.
 */
import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const env = import.meta.env as unknown as Record<string, string | undefined>;
const url = env.VITE_SUPABASE_URL;
const anon = env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(url && anon);

export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(url as string, anon as string, {
      auth: { persistSession: true, autoRefreshToken: true },
    })
  : null;
